import GenericPopover from "@Popover/components/GenericPopover";
import React from "react";
import StationsPopover from "@SearchResults/components/Popover/StationsPopover/StationsPopover";
import Row from "@Containers/components/Row";
import Translation from "@Translation/components/Translation";
import IconLocationMarker from "@Icons/IconLocationMarker";
import {Colors} from "@Styles/Colors.style";
import TravelInfoWithDurationType from "@Route/types/travelInfo/TravelInfoWithDuration.type";
import TravelInfoType from "@Route/types/travelInfo/TravelInfo.type";

interface StationsPopoverContainerProps {
    travelInfo: TravelInfoWithDurationType | TravelInfoType,
}

const StationsPopoverContainer = ({travelInfo}: StationsPopoverContainerProps) => {
    const displayTrigger = () => (
        <Row center gap>
            <IconLocationMarker
                fill={Colors.primaryColor}
                width={12}
                height={12}
            />
            <Translation translationKey="sys.click_to_see_stations"/>
        </Row>
    )

    const displayOverlay = () => (
        <StationsPopover
            travelInfo={travelInfo}
        />
    )

    return (
        <GenericPopover
            trigger={displayTrigger()}
            overlay={displayOverlay()}
            id="route-stations-overlay"
            placement="bottom"
        />
    )
}

export default StationsPopoverContainer